// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"243":"93b7dc47","554":"22dba98e","968":"91a17789"}[chunkId] + ".css";
};